import {Box, IconButton, Stack, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {appStyles} from "../../../../../AppStyles.ts";
import type {ResolverType} from "../../../../../sdo/Resolver.ts";
import {RESOLVER_TYPE_META} from "../../../../../sdo/Resolver.ts";

const ALL_TYPES = Object.keys(RESOLVER_TYPE_META) as ResolverType[];

interface ResolverCreateBarProps {
    onSelect: (type: ResolverType) => void;
    onClose: () => void;
}

function ResolverCreateBar({onSelect, onClose}: ResolverCreateBarProps) {
    return (
        <Box sx={{display: "flex", justifyContent: "center", marginTop: "8px", marginBottom: "4px"}}>
            <Box sx={{
                backgroundColor: "rgba(6, 16, 20, 0.7)",
                border: "1px solid rgba(112, 147, 160, 0.35)",
                borderRadius: "10px",
                padding: "16px 20px",
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "center",
            }}>
                <Stack direction="row" alignItems="center" sx={{width: "100%", marginBottom: "4px"}}>
                    <Box sx={{flex: 1}}/>
                    <Typography sx={{
                        color: "#38ff82",
                        fontSize: "0.80rem",
                        fontWeight: 600,
                    }}>
                        Create New Resolver
                    </Typography>
                    <Box sx={{flex: 1, display: "flex", justifyContent: "flex-end"}}>
                        <IconButton size="small" onClick={onClose} sx={{color: "#ffffff"}}>
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    </Box>
                </Stack>

                <Typography sx={{
                    color: "rgba(242, 245, 250, 0.35)",
                    fontSize: "0.60rem",
                    fontStyle: "italic",
                    marginBottom: "10px",
                }}>
                    Select which resolver type you would like to add
                </Typography>

                <Box sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    justifyContent: "center",
                }}>
                    {ALL_TYPES.map((resolverType) => (
                        <Box
                            key={resolverType}
                            onClick={() => onSelect(resolverType)}
                            sx={{
                                ...appStyles.cardGeneralStyle,
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "6px",
                                padding: "8px 14px",
                                cursor: "pointer",
                                minWidth: "100px",
                                border: "0.5px solid rgba(112, 147, 160, 0.3)",
                                "&:hover": {
                                    transform: "translateY(-2px) scale(1.02)",
                                    borderColor: "#02cfee",
                                    boxShadow: "0 4px 12px rgba(2, 207, 238, 0.15)",
                                },
                            }}
                        >
                            <img
                                src={RESOLVER_TYPE_META[resolverType].icon}
                                width={16} height={16}
                                alt={RESOLVER_TYPE_META[resolverType].displayName}
                                style={{opacity: 0.8}}
                            />
                            <Typography sx={{
                                color: "#f2f5fa",
                                fontSize: "0.72rem",
                                fontWeight: 400,
                                whiteSpace: "nowrap",
                            }}>
                                {RESOLVER_TYPE_META[resolverType].displayName}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default ResolverCreateBar;
